/*@flow*/
import * as t from 'lib/t';
import enumList from './util/enumList';
import enumsFor from './util/enumsFor';
import { Id, NormalizedNumber } from 'types/tcomb';
import mkTagTemplate from 'lib/templates/mkTagTemplate';
import naturalSorter from 'lib/naturalSorter';
import isEmbedded from "lib/isEmbedded";

const config = {
  id: t.maybe(Id).opt({ type: 'hidden' }),
  name: t.String,
  address: t.String.opt({
    template: 'LocationPickerTemplate',
  }),
  mapLabel: t.maybe(t.String),
  description: t.maybe(t.String),
  theGeom: t.String.opt({ type: 'hidden' }),
  status: t.String.options({
    template: 'BuildingStatus',
    attrs: {
      placeholder: 'Choose status',
      classNamePrefix: 'Select',
    },
  }),
  visibility: enumsFor('visibility'),
  category: t.maybe(t.String).opt({
    template: 'BuildingCategory',
    attrs: {
      placeholder: 'Choose a category',
    },
  }),
  tags: t.maybe(t.list(t.String)).opt({
    template: mkTagTemplate('buildings'),
    attrs: {
      placeholder: 'Select...',
    },
  }),
  photoUrls: t.maybe(t.list(t.String)).options({
    label: 'Photo(s)',
    template: 'PhotoUploaderTemplate',
    help: 'Photos must be larger than 600px wide.',
  }),
  documentsAttributes: t
    .maybe(t.list(t.struct({ name: t.String, url: t.String })))
    .opt({
      label: 'Additional Information & Supporting Documents',
      template: 'DocumentUploaderTemplate',
      help: 'Accepted file types: pdf, png, jpg.',
    }),
  propertyMunicipalId: t
    .maybe(NormalizedNumber)
    .opt({ label: 'Municipal Property ID' }),
  bin: t.maybe(NormalizedNumber).opt({ label: 'BIN #' }),
  propertyManagement: t.maybe(t.String),
  contact: t.maybe(t.String).opt({ label: 'Contact Name' }),
  contactEmail: t.maybe(t.String),
  contactPhone: t.maybe(t.String),
  uses: t.maybe(t.list(t.String)).opt({
    label: 'Use',
    template: 'SelectTemplate',
    categories: enumList.use.sort(naturalSorter),
    isMulti: true,
    attrs: {
      placeholder: 'Choose a use',
      classNamePrefix: 'Select',
    },
  }),
  amenities: t.maybe(t.list(t.String)).options({
    template: mkTagTemplate('buildings'),
    attrs: {
      placeholder: 'Choose an amenity',
      classNamePrefix: 'Select',
    },
  }),
  numStories: t.maybe(NormalizedNumber).opt({ label: 'Number of stories' }),
  numUnits: t.maybe(NormalizedNumber).opt({ label: 'Number of units' }),
  housingUnitsTotal: t
    .maybe(NormalizedNumber)
    .opt({ label: 'Total housing units' }),
  numAffordableUnits: t
    .maybe(NormalizedNumber)
    .opt({ label: 'Number of afforable units' }),
  numMarketRateUnits: t
    .maybe(NormalizedNumber)
    .opt({ label: 'Number of market rate units' }),
  totalFloorAreaSqft: t.maybe(NormalizedNumber).opt({
    label: 'Total floor area (sqft)',
  }),
  residentialSqFt: t
    .maybe(NormalizedNumber)
    .opt({ label: 'Residential area (sqft)' }),
  retailSqFt: t.maybe(NormalizedNumber).opt({ label: 'Retail area (sqft)' }),
  officeSqFt: t.maybe(NormalizedNumber).opt({ label: 'Office area (sqft)' }),
  commercialSqFt: t
    .maybe(NormalizedNumber)
    .opt({ label: 'Commercial area (sqft)' }),
  hotelSqFt: t.maybe(NormalizedNumber).opt({ label: 'Hotel area (sqft)' }),
  industrialSqFt: t
    .maybe(NormalizedNumber)
    .opt({ label: 'Industrial area (sqft)' }),
  otherSqFt: t.maybe(NormalizedNumber).opt({ label: 'Other area (sqft)' }),
  amenitiesSqFt: t
    .maybe(NormalizedNumber)
    .opt({ label: 'Amenities area (sqft)' }),
  rentableAreaSqft: t
    .maybe(NormalizedNumber)
    .opt({ label: 'Rentable area (sqft)' }),
  typicalFloorSizeSqft: t.maybe(NormalizedNumber).opt({
    label: 'Typical floor size (sqft)',
  }),
  totalUnits: t.maybe(NormalizedNumber).opt({ label: 'Total units' }),
  yearBuilt: t.maybe(NormalizedNumber),
  yearLastRenovated: t.maybe(NormalizedNumber),
  phone: t.maybe(t.String).opt({ attrs: { type: 'phone' } }),
  url: t.maybe(t.String).opt({ label: 'Website', attrs: { type: 'url' } }),
  notes: t.maybe(t.String).opt({
    type: 'textarea',
    template: 'TextEditorTemplate',
  }),

  contactIds: t.maybe(t.list(Id)).opt({
    before: {
      tag: 'h3',
      props: { children: 'Associated Records', className: 'mt-5' },
    },
    after: {
      tag: 'div',
      props: { className: 'mb-5 mt-5' },
    },
    template: 'Contacts',
    label: 'Contacts',
    attrs: {
      placeholder: 'Select Contact',
      classNamePrefix: 'SelectRecordContacts',
    },
    hideWhen: isEmbedded,
  }),
};
export default t.struct(config, 'Building').opt<any>({ legend: '' });
